var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook2 = function SvgFacebook2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#081B36",
    fillOpacity: 0.5,
    d: "m9.345 10.125.519-3.258H6.62V4.755c0-.891.453-1.76 1.905-1.76H10V.22A19 19 0 0 0 7.384 0C4.715 0 2.968 1.56 2.968 4.385v2.482H0v3.258h2.968V18h3.653v-7.875z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v18H0z"
  })))));
};
export default SvgFacebook2;